import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { materialDensityPresets } from "./presets";

type MaterialDropdownProps = {
  label: string;
  customLabel: string;
  values: Record<string, string>;
  selectedKey?: string;
  onSelect: (density: number) => void;
};

export function MaterialDropdown({ label, customLabel, values, selectedKey, onSelect }: MaterialDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const selectedPreset = materialDensityPresets.find((preset) => preset.key === selectedKey);

  return (
    <div className={["material-dropdown", isOpen ? "is-open" : "", selectedPreset ? "" : "is-custom"].filter(Boolean).join(" ")}>
      <button
        type="button"
        className="material-dropdown-trigger"
        aria-expanded={isOpen}
        aria-haspopup="listbox"
        onClick={() => setIsOpen((current) => !current)}
      >
        <span>{label}</span>
        <strong>{selectedPreset ? values[selectedPreset.key] : customLabel}</strong>
        <ChevronDown size={17} aria-hidden="true" />
      </button>
      {isOpen ? (
        <div className="material-dropdown-list" role="listbox" aria-label={label}>
          {materialDensityPresets.map((preset) => {
            const isActive = preset.key === selectedKey;

            return (
              <button
                key={preset.key}
                type="button"
                className={isActive ? "material-dropdown-option is-active" : "material-dropdown-option"}
                role="option"
                aria-selected={isActive}
                onClick={() => {
                  onSelect(preset.density);
                  setIsOpen(false);
                }}
              >
                <span>{values[preset.key]}</span>
                <strong>{preset.density.toFixed(2)} g/cm³</strong>
              </button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
